import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconAttachment';
/** Renders an SVG icon. */
const SvgAttachment = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M22.507 6.535a3 3 0 0 0-4.243 0L6.95 17.85a5 5 0 0 0 7.071 7.071l14.142-14.142a1 1 0 1 1 1.415 1.414L15.436 26.334a7 7 0 1 1-9.9-9.9L16.85 5.122a5 5 0 0 1 7.07 7.071L12.608 23.506a3 3 0 1 1-4.242-4.243l9.192-9.192a1 1 0 1 1 1.414 1.414L9.78 20.678a1 1 0 0 0 1.414 1.414l11.314-11.314a3 3 0 0 0 0-4.243Z"
      />
    </svg>
  );
};
SvgAttachment.displayName = displayName;
export default SvgAttachment;
